// extracted by mini-css-extract-plugin
export default {"content-container":"App_content-container__yhA16"};